module.exports = __webpack_public_path__ + "static/media/folder_open-24px.19825833.svg";